<template>
  <div>
    <div class="exam-banner">
      <div class="exam-banner-head">
        <button class="exam-banner-close" @click="$emit('close')" title="Fermer">✕</button>
        <h1 class="exam-banner-title">Heure et émargement</h1>
      </div>
    </div>

    <div class="emargement-tabs">
      <button class="emargement-tab" :class="{ active: activeTab === 'terminer' }" @click="activeTab = 'terminer'">
        Cours à terminer
        <span class="emargement-tab-count" v-if="countTerminer > 0">{{ countTerminer }}</span>
      </button>
      <button class="emargement-tab" :class="{ active: activeTab === 'emarger' }" @click="activeTab = 'emarger'">
        Heures à émarger
        <span class="emargement-tab-count" v-if="countEmarger > 0">{{ countEmarger }}</span>
      </button>
    </div>

    <div class="emargement-section" v-if="activeTab === 'terminer'">
      <DataTable :value="coursNonTermines" dataKey="id" tableStyle="width: 100%">
        <Column header="Date">
          <template #body="slotProps">{{ slotProps.data.date }} · {{ slotProps.data.heureDebut }} - {{ slotProps.data.heureFin }}</template>
        </Column>
        <Column field="lieu" header="Lieu"></Column>
        <Column field="eleve" header="Élève"></Column>
        <Column field="moniteur" header="Moniteur"></Column>
        <Column header="Action">
          <template #body="slotProps">
            <button class="btn btn-primary" :disabled="loadingTerminerId === slotProps.data.id" @click="terminerCours(slotProps.data)">Terminer le cours</button>
          </template>
        </Column>
      </DataTable>
      <p class="emargement-empty" v-if="coursNonTermines.length === 0">Aucun cours à terminer.</p>
      <Paginator :rows="10" :totalRecords="countTerminer" @page="onPaginateTerminer" v-if="countTerminer > 10"></Paginator>
    </div>

    <div class="emargement-section" v-if="activeTab === 'emarger'">
      <div class="emargement-section-head">
        <h2 class="emargement-section-title">Cours non émargés depuis plus de 2 semaines</h2>
        <button class="btn btn-primary" :disabled="loadingEnvoyer" @click="envoyer">Envoyer</button>
      </div>
      <DataTable :value="elevesNonEmarges" dataKey="ideleve" tableStyle="width: 100%">
        <Column field="eleve" header="Élève"></Column>
        <Column field="dateLaPlusAncienne" header="Cours le plus ancien non émargé"></Column>
        <Column field="nombre" header="Nb cours non émargés"></Column>
      </DataTable>
      <p class="emargement-empty" v-if="elevesNonEmarges.length === 0">Aucun élève concerné.</p>
      <Paginator :rows="10" :totalRecords="countEmarger" @page="onPaginateEmarger" v-if="countEmarger > 10"></Paginator>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["close"],

  data() {
    return {
      activeTab: "terminer",
      coursNonTermines: [],
      countTerminer: 0,
      offsetTerminer: 0,
      elevesNonEmarges: [],
      countEmarger: 0,
      offsetEmarger: 0,
      loadingTerminerId: null,
      loadingEnvoyer: false,
    };
  },

  mounted() {
    this.getCoursNonTermines(0);
    this.getElevesNonEmarges(0);
  },

  methods: {
    getCoursNonTermines(offset) {
      this.offsetTerminer = offset;
      window.api
        .get("/apointments/non-terminees/agence/" + this.$store.state.user.agence.id + "/offset/" + offset, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.coursNonTermines = response.data.cours;
          this.countTerminer = response.data.count;
        })
        .catch((error) => { console.log(error); });
    },

    getElevesNonEmarges(offset) {
      this.offsetEmarger = offset;
      window.api
        .get("/apointments/non-emarges/agence/" + this.$store.state.user.agence.id + "/offset/" + offset, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.elevesNonEmarges = response.data.eleves;
          this.countEmarger = response.data.count;
        })
        .catch((error) => { console.log(error); });
    },

    onPaginateTerminer(e) {
      this.getCoursNonTermines(e.first);
    },

    onPaginateEmarger(e) {
      this.getElevesNonEmarges(e.first);
    },

    terminerCours(item) {
      if (!window.confirm("Marquer ce cours comme terminé ? La fiche de cours (heures, compétences) ne sera pas remplie.")) {
        return;
      }
      this.loadingTerminerId = item.id;
      window.api
        .patch(
          "/apointment/" + item.id + "/terminer-rapide",
          {},
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then(() => {
          this.loadingTerminerId = null;
          this.getCoursNonTermines(this.offsetTerminer);
        })
        .catch((error) => {
          this.loadingTerminerId = null;
          console.log(error);
        });
    },

    envoyer() {
      if (!window.confirm("Envoyer un mail à tous les élèves ayant des cours non émargés depuis plus de 2 semaines ?")) {
        return;
      }
      this.loadingEnvoyer = true;
      window.api
        .post(
          "/apointments/non-emarges/agence/" + this.$store.state.user.agence.id + "/envoyer",
          {},
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then((response) => {
          this.loadingEnvoyer = false;
          window.alert(response.data.nbEnvoyes + " mail(s) envoyé(s).");
        })
        .catch((error) => {
          this.loadingEnvoyer = false;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.emargement-tabs {
  display: flex;
  gap: 8px;
  margin: 0 20px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.emargement-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #7a7168;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color .15s, border-color .15s;
}

.emargement-tab:hover {
  color: #1a73e8;
}

.emargement-tab.active {
  color: #1a73e8;
  border-bottom-color: #1a73e8;
}

.emargement-tab-count {
  background: #e2e8f0;
  color: #1a1f2e;
  font-size: 11px;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 7px;
}

.emargement-tab.active .emargement-tab-count {
  background: #1a73e8;
  color: #fff;
}

.emargement-section {
  margin: 0 20px 24px;
}

.emargement-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.emargement-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 0 0 10px;
}

.emargement-section-head .emargement-section-title {
  margin: 0;
}

.emargement-empty {
  margin: 10px 0 0;
  font-size: 13px;
  color: #7a7168;
}

/* ── Bannière (style aligné sur les autres splits) ── */
.exam-banner {
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.exam-banner-head {
  position: relative;
  background-color: #1a73e8;
  padding: 20px 24px;
  text-align: center;
}

.exam-banner-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: #ef4444;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-banner-close:hover {
  background: #dc2626;
}

.exam-banner-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #ffffff;
}
</style>
